export default {
  data: () => ({
    valueCopy: undefined,
  }),
  computed: {
    localeCode() {
      return import.meta.env.VUE_APP_I18N_LOCALE?.split('_')[0];
    },
    isSaveDisabled() {
      return !this.value || this.valueCopy === this.value;
    },
  },
  watch: {
    isMenuVisible(nV) {
      if (nV) {
        this.valueCopy = this.getValue();
      }
    },
  },
  methods: {
    onClickOutside() {
      this.$emit('input', this.valueCopy);
      this.activeTab = 0;
    },
    save(setLoading, customCallback) {
      this.setValue();
      this.$emit('saveDate', this.getValue());
      if (customCallback) {
        customCallback(
          this.getValue(),
          () => {
            this.isMenuVisible = false;
            this.activeTab = 0;
          },
          setLoading
        );
      } else {
        this.isMenuVisible = false;
        this.activeTab = 0;
      }
    },
    cancel() {
      this.$emit('input', this.valueCopy);
      this.isMenuVisible = false;
      this.activeTab = 0;
    },
    closeConditional() {
      return this.isMenuVisible;
    },
    include() {
      return [document.querySelector('.included')];
    },
  },
};
